(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dod-occasion-home"] && !Shopify.designMode) return;
  try {
    
  function initializeOccasionHome(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const buttons = [...root.querySelectorAll('[data-occasion-filter]')];
    if (!buttons.length) return;
    const cards = [...root.querySelectorAll('[data-occasion-game]')];
    const status = root.querySelector('[data-occasion-status]');
    const filters = root.querySelector('[data-occasion-filters]');
    const grid = root.querySelector('.dod-occasions__products');
    const browseAll = root.querySelector('[data-occasion-browse-all]');
    const browseLabel = root.querySelector('[data-occasion-browse-label]');

    function select(category) {
      if (!buttons.some(button => button.dataset.occasionFilter === category)) category = 'all';
      let count = 0;
      cards.forEach(card => {
        const show = category === 'all' || card.dataset.category.split(/\s+/).includes(category);
        card.hidden = !show;
        if (show) count++;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.occasionFilter === category)));
      const active = buttons.find(button => button.dataset.occasionFilter === category);
      status.textContent = status.dataset.message.replace('[count]', String(count)).replace('[category]', active.textContent.trim());
      if (browseAll) {
        const key = category.charAt(0).toUpperCase() + category.slice(1);
        browseAll.href = browseAll.dataset['url' + key] || browseAll.dataset.urlAll;
        browseLabel.textContent = browseAll.dataset['label' + key] || browseAll.dataset.labelAll;
      }
    }
    buttons.forEach(button => button.addEventListener('click', () => {
      const pinned = filters.getBoundingClientRect().top <= parseFloat(getComputedStyle(filters).top) + 1;
      select(button.dataset.occasionFilter);
      if (pinned) {
        root.style.setProperty('--dod-filter-height', `${filters.offsetHeight}px`);
        grid.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
    }));
  }
  document.querySelectorAll('[data-occasion-home]').forEach(initializeOccasionHome);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-occasion-home]').forEach(initializeOccasionHome));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-product"]) return;
  try {
    
  function initializeQuickBuy(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('.dod-qb__form');
    const buttons = [...root.querySelectorAll('[data-qb-submit]')];
    const status = root.querySelector('[data-qb-status]');
    const errors = [...root.querySelectorAll('[data-qb-error], [data-qb-sticky-error]')];
    const slides = [...root.querySelectorAll('[data-qb-slide]')];
    const thumbnails = [...root.querySelectorAll('[data-qb-thumbnail]')];
    const zoom = root.querySelector('.dod-qb__zoom');
    const zoomImage = root.querySelector('[data-qb-zoom-image]');
    const selector = root.querySelector('[data-qb-variant]');
    const qtyInput = root.querySelector('[data-qb-qty-input]');
    const comingSoon = root.dataset.comingSoon === 'true';
    let busy = false;
    let available = buttons.length ? !buttons[0].disabled : false;
    function updateButtons() {
      buttons.forEach(button => {
        button.disabled = busy || !available;
        button.setAttribute('aria-busy', String(busy));
        button.querySelector('[data-qb-submit-label]').textContent = busy ? root.dataset.adding : available ? root.dataset.addLabel : root.dataset.soldLabel;
      });
    }
    function showError(message) {
      errors.forEach(error => { error.textContent = message; error.hidden = !message; });
    }
    root.querySelectorAll('[data-qb-qty]').forEach(button => button.addEventListener('click', () => {
      if (!qtyInput) return;
      const step = Number(qtyInput.step) || 1;
      const min = Number(qtyInput.min) || 1;
      const max = qtyInput.max ? Number(qtyInput.max) : Infinity;
      const next = Math.min(max, Math.max(min, (Number(qtyInput.value) || min) + step * Number(button.dataset.qbQty)));
      qtyInput.value = next;
    }));
    const sticky = root.querySelector('.dod-qb__sticky');
    const mainButton = form ? form.querySelector('[data-qb-submit]') : null;
    if (sticky && mainButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(mainButton);
    }
    const stage = root.querySelector('[data-qb-track]');
    const strip = root.querySelector('.dod-qb__thumbnails');
    const previous = root.querySelector('[data-qb-prev]');
    const next = root.querySelector('[data-qb-next]');
    let activeIndex = -1;
    const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    function markPhoto(index) {
      if (index === activeIndex || !slides[index]) return;
      activeIndex = index;
      slides.forEach((slide, i) => {
        slide.inert = i !== index;
        if (i !== index) {
          slide.querySelectorAll('video').forEach(video => video.pause());
          slide.querySelectorAll('[data-qb-external]').forEach(container => {
            container.querySelector('iframe')?.remove();
            container.querySelector('[data-qb-video-launch]').hidden = false;
          });
        }
      });
      thumbnails.forEach((thumbnail, i) => thumbnail.setAttribute('aria-current', String(i === index)));
      if (strip && thumbnails[index]) {
        const thumb = thumbnails[index];
        strip.scrollTo({ left: thumb.offsetLeft - strip.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2, behavior: motion() });
      }
      const counter = root.querySelector('[data-qb-counter]');
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }
    function choosePhoto(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      stage.scrollTo({ left: index * stage.clientWidth, behavior: motion() });
      markPhoto(index);
    }
    if (stage && slides.length) {
      markPhoto(0);
      let scrollFrame;
      stage.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => markPhoto(Math.round(stage.scrollLeft / stage.clientWidth)));
      }, { passive:true });
      previous?.addEventListener('click', () => choosePhoto(activeIndex - 1));
      next?.addEventListener('click', () => choosePhoto(activeIndex + 1));
      const galleryKeys = (event, index) => {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : Math.max(0, Math.min(slides.length - 1, index + (event.key === 'ArrowRight' ? 1 : -1)));
        choosePhoto(nextIndex);
        if (event.currentTarget !== stage && thumbnails[nextIndex]) thumbnails[nextIndex].focus({preventScroll:true});
      };
      thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', event => { event.preventDefault(); choosePhoto(index); });
        thumbnail.addEventListener('keydown', event => galleryKeys(event, index));
      });
      stage.addEventListener('keydown', event => { if (event.target === stage) galleryKeys(event, activeIndex); });
      if ('ResizeObserver' in window) new ResizeObserver(() => { stage.scrollTo({left:Math.max(0,activeIndex)*stage.clientWidth,behavior:'instant'}); }).observe(stage);
    }
    root.querySelectorAll('[data-qb-video-launch]').forEach(button => button.addEventListener('click', () => {
      const container = button.closest('[data-qb-external]');
      container.appendChild(container.querySelector('template').content.cloneNode(true));
      button.hidden = true;
      container.querySelector('iframe')?.focus();
    }));
    root.querySelectorAll('[data-qb-image-open]').forEach(link => link.addEventListener('click', event => {
      if (!zoom.showModal) return;
      event.preventDefault();
      zoomImage.src = link.href;
      zoomImage.alt = link.querySelector('img').alt;
      zoom.showModal();
    }));
    root.querySelector('[data-qb-zoom-close]').addEventListener('click', () => zoom.close());
    zoom.addEventListener('click', event => { if (event.target === zoom) zoom.close(); });
    if (selector) selector.addEventListener('change', () => {
      const option = selector.selectedOptions[0];
      available = !comingSoon && option.dataset.available === 'true';
      root.querySelectorAll('[data-qb-price]').forEach(price => price.textContent = option.dataset.price);
      if (qtyInput) { qtyInput.min = option.dataset.quantity; qtyInput.value = option.dataset.quantity; }
      const mediaIndex = slides.findIndex(slide => slide.dataset.mediaId === option.dataset.media);
      if (mediaIndex >= 0) choosePhoto(mediaIndex);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
      showError('');
      updateButtons();
    });
    if (form) form.addEventListener('submit', async event => {
      if (!window.fetch) return;
      event.preventDefault();
      if (busy || !available) return;
      busy = true;
      showError('');
      updateButtons();
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const data = new FormData(form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        data.append('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        data.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(event.submitter || document.activeElement);
      }
      try {
        const response = await fetch(root.dataset.addUrl + '.js', { method:'POST', headers:{ 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' }, body:data });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : root.dataset.error);
        status.textContent = root.dataset.added;
        if (cart && typeof cart.renderContents === 'function' && result.sections && Object.values(result.sections).every(Boolean)) {
          try {
            cart.classList.remove('is-empty');
            cart.renderContents(result);
          } catch (error) {
            window.location.assign(root.dataset.cartUrl);
          }
        } else {
          window.location.assign(root.dataset.cartUrl);
        }
      } catch (error) {
        showError(error instanceof TypeError ? root.dataset.error : error.message || root.dataset.error);
      } finally {
        busy = false;
        updateButtons();
      }
    });
  }
  document.querySelectorAll('[data-quick-buy]').forEach(initializeQuickBuy);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-quick-buy]').forEach(initializeQuickBuy));

  } catch(e) { console.error(e); }
})();
})();
